import { ReactNode } from 'react'

enum ButtonSize {
	sm = 'px-3 py-2',
	md = 'px-4 py-3',
	lg = 'px-5 py-3.5',
}

enum ButtonColor {
	primary = 'bg-brand-500 text-white shadow-theme-xs hover:bg-brand-600 disabled:bg-brand-300',
	secondary = 'bg-white text-gray-700 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 dark:bg-gray-800 dark:text-gray-400 dark:ring-gray-700 dark:hover:bg-white/[0.03] dark:hover:text-gray-300',
	danger = 'bg-red-600 hover:bg-red-700 active:bg-red-800 disabled:bg-gray-400 text-white',
	success = 'bg-green-600 hover:bg-green-700 active:bg-green-800 disabled:bg-gray-400 text-white',
	warning = 'bg-yellow-500 hover:bg-yellow-600 active:bg-yellow-700 disabled:bg-gray-400 text-white',
}

interface ButtonProps {
	children: ReactNode | ReactNode[]
	className?: string
	size?: 'sm' | 'md' | 'lg'
	color?: 'primary' | 'secondary' | 'danger' | 'success' | 'warning'
	disabled?: boolean
	onClick?: () => void
}

const sizeMap: Map<string, ButtonSize> = new Map([
	['sm', ButtonSize.sm],
	['md', ButtonSize.md],
	['lg', ButtonSize.lg],
])

const colorMap: Map<string, string> = new Map([
	['primary', ButtonColor.primary],
	['secondary', ButtonColor.secondary],
	['danger', ButtonColor.danger],
	['success', ButtonColor.success],
	['warning', ButtonColor.warning],
])

export const Button = ({ children, className, disabled, color, size, onClick }: ButtonProps) => {
	const pickedSize = sizeMap.get(size || 'md') || ButtonSize.md
	const pickedColor = colorMap.get(color || 'primary') || ButtonColor.primary

	return (
		<button
			onClick={onClick}
			disabled={disabled}
			className={`inline-flex items-center justify-center gap-2 rounded-lg transition ${pickedColor} ${pickedSize} text-sm disabled:cursor-not-allowed ${className}`}
		>
			{children}
		</button>
	)
}
